import React, { Component } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import MonitorService from 'src/controllers/MonitorService';
import { setMonitorToken, setMonitorConnected, setMonitorConnectionLost } from 'src/redux/agentSlice';
import IncomingCallsSummary from './widgets/incomingcallssummary';
import OutgoingCallsSummary from './widgets/outgoingcallssummary';
import SocialSummary from './widgets/socialsummary';
import QueuedCalls from './widgets/queuedcalls';
import QueuedChats from './widgets/queuedchats';
import Agentspanel from './widgets/agentspanel/agentspanel';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import QueuedchatsInbox from './widgets/queuedchatsinbox';
import Searchinbox from './widgets/searchinbox';
import { useOutletContext } from 'react-router-dom';
class Dashboard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            connected: false,
            view: "monitor"
        };

        this.monitorClick = this.monitorClick.bind(this);
        this.queueClick = this.queueClick.bind(this);
        this.serachClick = this.serachClick.bind(this);
    }

    monitorClick(e) {
        this.setState({ view: "monitor" });
    }

    queueClick(e) {
        this.setState({ view: "queue" });
    }

    serachClick(e) {
        this.setState({ view: "search" });
    }

    render() {
        return (
            <>
                {
                    this.props.showInbox &&
                    <Row>
                        <Col lg={2} className={
                            "fs-4 pb-3 " +
                            (this.state.view === "monitor" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                        } onClick={this.monitorClick}>
                            <FontAwesomeIcon icon={duotone('chart-pie')} /> <span className='chattab'> {this.props.t("monitor")}</span>
                        </Col>
                        <Col lg={2} className={
                            "fs-4 pb-3 " +
                            (this.state.view === "queue" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                        } onClick={this.queueClick}>
                            <FontAwesomeIcon icon={duotone('message-plus')} /> <span className='chattab'> {this.props.t("queuedchats")}</span>
                        </Col>
                        <Col lg={2} className={
                            "fs-4 pb-3 " +
                            (this.state.view === "search" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                        } onClick={this.serachClick}>
                            <FontAwesomeIcon icon={duotone('magnifying-glass')} /> <span className='chattab'> {this.props.t("search2")}</span>
                        </Col>
                    </Row>
                }
                {
                    this.state.view === "monitor" &&
                    <div style={{ position: "relative", right: "10px" }}>
                        {
                            (this.props.connected && !this.props.connectionLost && MonitorService?.stompClient?.connected) &&
                            <>
                                <Row >
                                    <Col xxl={4}>
                                        <IncomingCallsSummary></IncomingCallsSummary>
                                    </Col>
                                    <Col xxl={4}>
                                        <OutgoingCallsSummary></OutgoingCallsSummary>
                                    </Col>
                                    <Col xxl={4}>
                                        <SocialSummary></SocialSummary>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xxl={4} >
                                        <QueuedCalls></QueuedCalls>
                                    </Col>
                                    <Col xxl={4} >
                                        <QueuedChats></QueuedChats>
                                    </Col>
                                    <Col xxl={4}>
                                        <Agentspanel></Agentspanel>
                                    </Col>
                                </Row>
                            </>
                        }
                        {

                            (!this.props.connected && !this.props.connectionLost) &&
                            <>
                                <div className='d-flex flex-column flex-center' style={{ position: "relative", top: "50%" }}>
                                    <div className="fs-1 text-center">{this.props.t("dashboard")}</div>

                                    <div className="fs-4 text-muted text-center">{this.props.t("sessionclosedmessage")}</div>
                                    <div className='nochatsimg'></div>
                                    <Row>
                                        <Col>
                                            <Button variant="primary" onClick={this.props.reconnect}>{this.props.t("reconnect")}</Button>
                                        </Col>
                                    </Row>
                                </div>
                            </>
                        }
                        {

                            (!this.props.connected && this.props.connectionLost) &&
                            <>
                                <div className='d-flex flex-column flex-center' style={{ position: "relative", top: "50%" }}>
                                    <div className="fs-1 text-center">{this.props.t("dashboard")}</div>
                                    <div className="fs-4 text-muted text-center">{this.props.t("connectionlostmonitor")}</div>
                                    <div className="fs-4 text-muted text-center">{this.props.t("reconnecting")}</div>
                                    <div className='nochatsimg'></div>
                                </div>
                            </>
                        }
                    </div>
                }

                {
                    this.state.view === "queue" &&
                    <Row>
                        <Col xxl={12} >
                            <QueuedchatsInbox></QueuedchatsInbox>
                        </Col>
                    </Row>
                }
                {
                    this.state.view === "search" &&
                    <Searchinbox />

                }
            </>)
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.agent.monitorToken,
        connected: state.agent.monitorConnected,
        userId: state.agent.userId,
        showDashboard: state.parameters.showDashboard,
        showInbox: state.parameters.showInbox,
        connectionLost: state.agent.monitorConnectionLost
    };
};

function DashboardWithOutletContext(props) {
    const context = useOutletContext();
    return <Dashboard {...props} {...context} />;
}


export default compose(
    connect(mapStateToProps, { setMonitorToken, setMonitorConnected, setMonitorConnectionLost }),
    withTranslation()
)(DashboardWithOutletContext);